import React from 'react';

const resources = [
  {
    icon: <img src="/img/icons/users-plus.svg" className="w-8 h-18" alt="users-plus" />,
    title: 'Introducer network',
    description: 'Build meaningful connections with mortgage introducers, IFAs, and estate agents to grow your business.',
    linkText: 'View introducer resources',
    link: '/professionals/resources/marketing-toolkit/mortgage-introducer',
  },
  {
    icon: <img src="/img/icons/colors_alt.svg" className="w-8 h-18" alt="colors" />,
    title: 'Ready-made resources',
    description: 'Choose from a collection of resources to help you engage with your target market and build your online'
      + ' presence.',
    linkText: 'View ready-made',
    link: 'https://puremediastorage.blob.core.windows.net/pure-web-media/toolkit/ready-made-toolkit.pdf',
  },
  {
    icon: <img src="/img/icons/check-done-2.svg" className="w-8 h-18" alt="check-done" />,
    title: 'Mix-and-match resources',
    description: 'Select the individual components to build your own branded resources and enhance your marketing strategy.',
    linkText: 'View mix-and-match',
    link: 'https://puremediastorage.blob.core.windows.net/pure-web-media/toolkit/create-your-own-toolkit.pdf',
  },
];

const arrowIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" className="ml-2" width="18" height="18" viewBox="0 0 18 18" fill="none">
    <path d="M3 9H15M15 9L10.5 4.5M15 9L10.5 13.5" stroke="#006EB7" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const ReadyMadeResources = () => (
  <div className="bg-[#F3F4F8]">
    <div className="container mx-auto">
      <p className="text-xl font-semibold text-[#006EB7] mb-3 pt-16 lg:pt-20">Your toolkit, your way</p>
      <h2 className="text-3xl md:text-4xl font-semibold text-[#0C0D1A] pb-8 w-[20rem] md:w-[40rem] lg:pb-16">
        Find the right toolkit to power your growth
      </h2>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10 lg:gap-20 pb-20">
        {resources.map((resource, index) => (
          <div key={index} className="space-y-4">
            <div className="bg-[#006EB7] w-12 h-12 rounded-lg flex items-center justify-center">
              {resource.icon}
            </div>
            <h2 className="text-lg font-semibold text-[#0C0D1A]">
              {resource.title}
            </h2>
            <p className="text-base text-[#0C0D1A] font-450">
              {resource.description}
            </p>
            {resource.link.startsWith('/')
              ? <a
                href={resource.link}
                rel="noopener noreferrer"
                className="plain-text-link font-semibold inline-flex items-center cursor-pointer"
              >
                {resource.linkText}
                {arrowIcon}
              </a>
              : <a
                href={resource.link}
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="plain-text-link font-semibold inline-flex items-center cursor-pointer"
              >
                {resource.linkText}
                {arrowIcon}
              </a>
            }
          </div>
        ))}
      </div>
    </div>
  </div>
);
